module.exports = __webpack_public_path__ + "img/legacy_2.8fed8e0e.jpg";